module.exports = __webpack_public_path__ + "img/appleRulesLock.7c34d51f.png";